(function () {
  'use strict';

  var STORAGE_KEY = 'bie_welcome_popup_seen';
  var API_URL = 'https://bib-shopify-production.up.railway.app/api/popup-signup';
  var IMAGE_URL = 'https://cdn.shopify.com/s/files/1/0953/6536/6101/files/Showroom_banner_1.png?v=1786900978';
  var TURNSTILE_SITE_KEY = '0x4AAAAAAE_r4TEeDeeaML6h';

  // Never show twice in the same browser, never to a signed-in customer (we already
  // have their details), and never on cart/checkout — don't interrupt a purchase.
  try {
    if (localStorage.getItem(STORAGE_KEY)) return;
  } catch (e) {}
  if (window.__bibCustomer && window.__bibCustomer.email) return;
  if (/^\/(cart|checkout)/.test(window.location.pathname)) return;

  function markSeen() {
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
  }

  function init() {
    var style = document.createElement('style');
    style.textContent = `
      #bie-popup-overlay {
        position: fixed; inset: 0; background: rgba(15,23,42,0.6);
        z-index: 10000; display: flex; align-items: center; justify-content: center;
        padding: 20px; opacity: 0; transition: opacity 0.3s ease;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      }
      #bie-popup-overlay.bie-open { opacity: 1; }
      #bie-popup-card {
        width: min(920px, 100%); max-height: 90vh; overflow: hidden;
        background: #0f172a; border-radius: 20px; display: flex;
        box-shadow: 0 30px 80px rgba(0,0,0,0.5);
        transform: scale(0.96) translateY(10px); transition: transform 0.3s ease;
      }
      #bie-popup-overlay.bie-open #bie-popup-card { transform: scale(1) translateY(0); }
      #bie-popup-image {
        flex: 1 1 42%; background-size: cover; background-position: center;
        min-height: 420px; display: none;
      }
      #bie-popup-body {
        flex: 1 1 58%; padding: 40px 40px 32px; position: relative;
        display: flex; flex-direction: column; justify-content: center;
        background: linear-gradient(180deg, rgba(30,58,138,0.35), rgba(15,23,42,1) 60%);
      }
      @media (min-width: 720px) {
        #bie-popup-image { display: block; }
      }
      #bie-popup-close {
        position: absolute; top: 16px; right: 16px; width: 32px; height: 32px;
        border-radius: 50%; border: none; background: rgba(255,255,255,0.1);
        color: #cbd5e1; font-size: 16px; cursor: pointer; line-height: 1;
      }
      #bie-popup-close:hover { background: rgba(255,255,255,0.2); color: #fff; }
      #bie-popup-eyebrow {
        color: #93c5fd; font-size: 12px; font-weight: 700; letter-spacing: 1.5px;
        text-transform: uppercase; margin: 0 0 10px;
      }
      #bie-popup-heading {
        color: #f8fafc; font-size: 30px; font-weight: 800; line-height: 1.15;
        margin: 0 0 12px;
      }
      #bie-popup-heading span { color: #60a5fa; }
      #bie-popup-sub {
        color: #cbd5e1; font-size: 14.5px; line-height: 1.6; margin: 0 0 24px;
      }
      .bie-popup-field {
        width: 100%; box-sizing: border-box; padding: 13px 16px; margin-bottom: 12px;
        border-radius: 10px; border: 1px solid rgba(148,163,184,0.3);
        background: rgba(255,255,255,0.06); color: #f8fafc; font-size: 14.5px;
      }
      .bie-popup-field::placeholder { color: #94a3b8; }
      .bie-popup-field:focus { outline: none; border-color: #3b82f6; background: rgba(255,255,255,0.1); }
      #bie-popup-submit {
        width: 100%; padding: 14px; border: none; border-radius: 10px; cursor: pointer;
        background: linear-gradient(135deg, #1d4ed8, #2563eb); color: #fff;
        font-size: 15px; font-weight: 700; margin-top: 4px;
        transition: transform 0.15s ease;
      }
      #bie-popup-submit:hover { transform: translateY(-1px); }
      #bie-popup-submit:disabled { opacity: 0.6; cursor: default; transform: none; }
      #bie-popup-error {
        color: #fca5a5; font-size: 13px; margin: 10px 0 0; display: none;
      }
      #bie-popup-fine {
        color: #64748b; font-size: 11.5px; line-height: 1.5; margin: 14px 0 0;
      }
      #bie-popup-thanks { text-align: left; }
      #bie-popup-thanks h2 { color: #f8fafc; font-size: 24px; margin: 0 0 10px; }
      #bie-popup-thanks p { color: #cbd5e1; font-size: 14.5px; line-height: 1.6; }
    `;
    document.head.appendChild(style);

    var overlay = document.createElement('div');
    overlay.id = 'bie-popup-overlay';
    overlay.innerHTML = `
      <div id="bie-popup-card">
        <div id="bie-popup-image" style="background-image:url('${IMAGE_URL}')"></div>
        <div id="bie-popup-body">
          <button id="bie-popup-close" aria-label="Close">✕</button>
          <div id="bie-popup-form-wrap">
            <p id="bie-popup-eyebrow">Welcome to Brand It Essex</p>
            <h2 id="bie-popup-heading">Get <span>10% off</span> your first order</h2>
            <p id="bie-popup-sub">Pop your name and email below and we'll send your code straight over, on us.</p>
            <form id="bie-popup-form" novalidate>
              <input class="bie-popup-field" type="text" id="bie-popup-name" placeholder="Full name" autocomplete="name" required>
              <input class="bie-popup-field" type="email" id="bie-popup-email" placeholder="Email address" autocomplete="email" required>
              <div style="position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden;" aria-hidden="true">
                <input type="text" id="bie-popup-website" name="website" tabindex="-1" autocomplete="off">
              </div>
              <div id="bie-turnstile" style="margin:2px 0 12px;"></div>
              <button type="submit" id="bie-popup-submit">Claim my 10% off</button>
              <p id="bie-popup-error"></p>
            </form>
            <p id="bie-popup-fine">Valid on full-price items only, excludes bundle deals. By signing up you agree to receive marketing emails from Brand It Essex. Unsubscribe any time.</p>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);
    var openedAt = Date.now();

    function close() {
      overlay.classList.remove('bie-open');
      setTimeout(function () { overlay.remove(); }, 300);
      markSeen();
    }

    overlay.querySelector('#bie-popup-close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    var form = overlay.querySelector('#bie-popup-form');
    var errorEl = overlay.querySelector('#bie-popup-error');
    var submitBtn = overlay.querySelector('#bie-popup-submit');

    // Cloudflare Turnstile — loaded on demand and rendered into the widget div
    // above the submit button. Managed mode usually verifies silently; the token
    // it hands back via callback is what the backend checks with Cloudflare.
    var turnstileToken = null;
    var turnstileWidgetId = null;
    (function loadTurnstile() {
      if (window.turnstile) { renderTurnstile(); return; }
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      s.async = true;
      s.defer = true;
      s.onload = renderTurnstile;
      document.head.appendChild(s);
    })();
    function renderTurnstile() {
      if (!window.turnstile) return;
      turnstileWidgetId = window.turnstile.render('#bie-turnstile', {
        sitekey: TURNSTILE_SITE_KEY,
        callback: function (token) { turnstileToken = token; },
        'expired-callback': function () { turnstileToken = null; },
        'error-callback': function () { turnstileToken = null; },
      });
    }
    function resetTurnstile() {
      turnstileToken = null;
      if (window.turnstile && turnstileWidgetId !== null) window.turnstile.reset(turnstileWidgetId);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var name = overlay.querySelector('#bie-popup-name').value.trim();
      var email = overlay.querySelector('#bie-popup-email').value.trim();
      errorEl.style.display = 'none';

      if (!name || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errorEl.textContent = 'Please pop in your name and a valid email address.';
        errorEl.style.display = 'block';
        return;
      }

      if (!turnstileToken) {
        errorEl.textContent = 'Please complete the verification just above.';
        errorEl.style.display = 'block';
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending your code...';

      fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: name,
          email: email,
          turnstileToken: turnstileToken,
          website: overlay.querySelector('#bie-popup-website').value,
          elapsedMs: Date.now() - openedAt,
        }),
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.success) {
            try {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({ event: 'welcome_popup_signup' });
            } catch (e) {}
            if (window.bibTrack) window.bibTrack('welcome_popup_signup', { event_category: 'Welcome Popup' });

            markSeen();
            var wrap = overlay.querySelector('#bie-popup-form-wrap');
            wrap.innerHTML = `
              <div id="bie-popup-thanks">
                <h2>You're in! 🎉</h2>
                <p>Check your inbox, your 10% code is on its way to <strong>${email.replace(/</g, '&lt;')}</strong>.</p>
              </div>`;
            setTimeout(close, 3500);
          } else {
            errorEl.textContent = (data && data.error) || 'Something went wrong, please try again.';
            errorEl.style.display = 'block';
            submitBtn.disabled = false;
            submitBtn.textContent = 'Claim my 10% off';
            resetTurnstile();
          }
        })
        .catch(function () {
          errorEl.textContent = 'Something went wrong, please try again.';
          errorEl.style.display = 'block';
          submitBtn.disabled = false;
          submitBtn.textContent = 'Claim my 10% off';
          resetTurnstile();
        });
    });

    requestAnimationFrame(function () {
      overlay.classList.add('bie-open');
    });
  }

  setTimeout(init, 2500);
})();
